import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  getPreferredLocale,
  LANGUAGE_RESPONSE_CACHE_HEADERS,
} from "@/lib/i18n/actions";

/**
 * The address printed on a table sticker. It carries no locale — the sticker is
 * printed once and scanned by guests who read different languages — so send the
 * guest on to the localized route before anything else happens.
 */
export const Route = createFileRoute("/qr/t/$token")({
  beforeLoad: async ({ params }) => {
    const preferredLocale = await getPreferredLocale();

    throw redirect({
      to: "/$locale/qr/t/$token",
      params: { locale: preferredLocale, token: params.token },
      replace: true,
      // The target depends on the visitor's cookie / Accept-Language, so it must
      // never be stored by a shared cache and handed to the next guest.
      headers: LANGUAGE_RESPONSE_CACHE_HEADERS,
    });
  },
});
